import React, { useContext, useEffect } from "react";
import {
    View,
    Flex,
    Text,
    Collection,
    Card,
    useTheme
} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import QuoteLine from './QuoteLine';
import PetBasicDetailsForQuote from './PetBasicDetailsForQuote';
import PlanFeatures from './PlanFeatures';
import {
    QuotesStateContext,
    QuotesDispatchContext,
    getQuotes,
} from "../contexts/quotes";


// Lightweight, display-only progress indicator. Does not drive any logic.
function QuoteStepper({ activeStep }) {
    const steps = ['Pet details', 'Choose plan', 'Checkout'];
    return (
        <Flex direction="row" gap="0.5rem" wrap="wrap" alignItems="center"
            style={{ fontSize: '0.85rem', margin: '0 0 0.25rem 0' }}>
            {steps.map((label, idx) => {
                const stepNo = idx + 1;
                const isActive = stepNo === activeStep;
                return (
                    <React.Fragment key={label}>
                        <span style={{
                            fontWeight: isActive ? 700 : 400,
                            color: isActive ? '#d6336c' : '#888'
                        }}>
                            {stepNo} {label}
                        </span>
                        {idx < steps.length - 1 && (
                            <span style={{ color: '#bbb' }} aria-hidden="true">&rarr;</span>
                        )}
                    </React.Fragment>
                );
            })}
        </Flex>
    );
}


export default function Quote1() {
    const { tokens } = useTheme();
    const { quotes, request } = useContext(QuotesStateContext);
    const dispatch = useContext(QuotesDispatchContext);

    // A real breed selection drives the premium query (filter is age_bracket + breed_group).
    const hasBreed = Boolean(request?.breed_group);
    const quoteList = Array.isArray(quotes) ? quotes : [];

    useEffect(() => {
        // Don't fetch (and don't show a "No Quotes" error) until the visitor has
        // actually picked a breed. Preserve the fetch once a breed is selected.
        if (!hasBreed) return;
        getQuotes(dispatch, { 'age': request?.age, 'breed_id': request?.breed_id, 'breed_label': request?.breed_label, 'breed_group': request?.breed_group });
    }, [dispatch, hasBreed, request?.age, request?.breed_id, request?.breed_label, request?.breed_group]);

    return (
        <Card variation={'outlined'}>
            <View backgroundColor={tokens.colors.background.primary}>
                <Flex rowGap={tokens.space.small}
                    direction={'column'} >
                    <QuoteStepper activeStep={hasBreed ? 2 : 1} />
                    <PetBasicDetailsForQuote key={'999999_1'} />
                    {!hasBreed ? (
                        <Card variation="outlined" padding="2rem" textAlign="center" key={'999999_empty'}>
                            <Text fontSize="1.1rem" fontWeight={600}>Pick your pet&rsquo;s age &amp; breed to see plans</Text>
                            <Text fontSize="0.9rem" color="#666" padding="0.5rem 0 0 0">
                                Choose the age bracket and start typing your pet&rsquo;s breed above, and we&rsquo;ll show the plans that fit.
                            </Text>
                        </Card>
                    ) : (
                        <Collection
                            type="grid"
                            templateColumns="1fr"
                            gap="0.75rem"
                            items={quoteList}
                            isPaginated={quoteList.length > 12}
                            itemsPerPage={12}
                            searchNoResultsFound={
                                <Card padding={'0px'} key={'999999_2'}>
                                    <PlanFeatures key={'9999999'} msg={'No plans match this age & breed yet — try another age bracket.'}></PlanFeatures>
                                </Card>
                            }
                        >
                            {(quote, index) => (
                                <div key={quote?.id}>
                                    <QuoteLine key={quote?.id} quote={{ key: quote?.id, id: quote?.id, plan: quote?.plan, sum_insured: quote?.sum_insured, premium_incl_gst: quote?.premium_incl_gst, premium_excl_gst:quote?.premium_excl_gst,age: request?.age, breed: request?.breed_label ,breed_group:request?.breed_group , microchip:false , quantity:1 }} />
                                </div>
                            )

                            }
                        </Collection>
                    )}
                </Flex>
            </View>
        </Card>
    );

}